// extracted by mini-css-extract-plugin
module.exports = {"dialog":"glH2yADrZruIq6O_peOby","date-box":"_17s1tHTxnaNEMCDcGh9Qb8","title":"a5Q3SzmU0MPSyRlHxkHSl","separator":"_33i_Bzje_x7kO3vzqph2Px"};